import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/templates/code.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Media block`}</h1>
    <p>{`The Box component is a low-level primitive used for layout purposes. It can be used to create grid layouts, apply padding or margin, and more.`}</p>
    <p>{`Here is an example of how the Box component can be used to apply padding and border around its children.`}</p>
    <pre><code parentName="pre" {...{}}>{`<MediaBlock
  heading="Heading"
  altText="This is altText"
  copy="This is copy"
  ctaText="This is CTA"
  ctaTarget="_blank"
/>
`}</code></pre>
    <h4>{`Properties`}</h4>
    <p>{`System props apply standard sets of properties to a component that can be used to alter its appearance on the fly.`}</p>
    <PropsTable name="MediaBlock" mdxType="PropsTable" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      